import React from "react"
import {Drawer, Form, Input, Row, Col, Button, Switch} from "antd"
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {compose} from "recompose";
import * as SelectionActions from "../../reducers/selection_builder";
import {withRouter} from "react-router";


class CreationDrawer extends React.Component {


    static propTypes = {
        insertGroup: PropTypes.func.isRequired
    };


    onSubmit = (e) => {
        e.preventDefault();
        const {match} = this.props;
        const urlId = match.params.id;

        this.props.form.validateFields((errors, values) => {
            if (!errors) {
                this.props.insertGroup(values, urlId);
                this.props.history.push(`/selection/builder/${urlId}`)
                this.props.toggleVisibility()
            }
        });
    };

    render() {
        const {visible, toggleVisibility, form: {getFieldDecorator}} = this.props;
        return <Drawer title="Create a new group item" width={720} placement="right" visible={visible} style={{
            height: 'calc(100% - 55px)',
            overflow: 'auto',
            paddingBottom: 53,
        }} onClose={toggleVisibility}>
            <Form onSubmit={this.onSubmit}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Name">
                            {getFieldDecorator('name', {
                                rules: [{required: false, message: 'Please enter a Name'}],
                            })(<Input placeholder="Please enter a Name"/>)}
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Active">
                            {getFieldDecorator('active', {
                                valuePropName: 'checked',
                                initialValue: true
                            })(
                                <Switch/>
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <div
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e8e8e8',
                        padding: '10px 16px',
                        textAlign: 'right',
                        left: 0,
                        background: '#fff',
                        borderRadius: '0 0 4px 4px',
                    }}
                >
                    <Button
                        style={{
                            marginRight: 8,
                        }}
                        onClick={toggleVisibility}
                    >
                        Cancel
                    </Button>
                    <Button onClick={this.onSubmit} type="primary">Submit</Button>
                </div>
            </Form>
        </Drawer>
    }

}

const mapStateToProps = state => ({
    overview: state.selection_builder.overview,
    overviewLoader: state.selection_builder.overviewLoader
});

const mapDispatchToProps = dispatch => ({
    insertGroup: bindActionCreators(SelectionActions, dispatch).createGroupSelections,
});

export default compose(
    withRouter,
    Form.create(),
    connect(mapStateToProps, mapDispatchToProps),
)(CreationDrawer);



// WEBPACK FOOTER //
// ./src/js/selection/create/CreationDrawer.js